import beian from '@/server/beian'
const layout = {
  state: {
    mainInnerHeight: 0, // 当前Main部分可用窗口高度
    mainMinHeight: 520, // 当前Main部分最小高度，固定不变
    route: {
      list: [], // 列表，格式为
      hasGet: false // 是否已获取路由
    },
    requestCount: {
      count: 0, // 当前请求数
      time: Date.now() // 当前时间戳
    } // 请求数据量
  },
  mutations: {
    SET_MAIN_INNERHEIGHT(state, height) {
      state.mainInnerHeight = height
    },
    SET_REQUEST_COUNT(state) {
      state.requestCount.count++
      state.requestCount.time = Date.now()
    },
    // 设置路由列表
    SET_ROUTE_LIST(state, data) {
      state.route = {
        list: data,
        hasGet: true
      }
    },
    SET_ROUTE_HAS_GET(state) {
      state.route.hasGet = true
    }
  },
  actions: {
    setRequestCount: (context) => {
      context.commit('SET_REQUEST_COUNT')
    },
    // 获取菜单
    async getMenu(context) {
      context.commit('SET_ROUTE_HAS_GET') // 提前设置true
      let response = await beian.get('/anythings')
      let data = response.data
      if (data['state'] === 1) {
        context.commit('SET_ROUTE_LIST', data['data'])
      }
    },
    getRouteHasGet: (context) => {}
  },
  getters: {
    mainInnerHeight: state => state.mainInnerHeight,
    routeHasGet: state => state.route.hasGet,
    routeList: state => state.route.list
  }
}
export default layout



// WEBPACK FOOTER //
// ./src/store/modules/layout.js